export default __webpack_public_path__ + "static/media/product.c382f643.jpg";